import React, { useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DashboardToolbar from "./components/dashboard/DashboardToolbar";
import DashboardBody from "./DashboardBody";
function DashboardAuthoring() {
  useEffect(() => {
    const url = new URL(window.location.href);
    const billingStatus = url.searchParams.get("billing_status");
    const billingPlan = url.searchParams.get("billing_plan");

    if (billingStatus !== "success") {
      return;
    }

    const planLabel = billingPlan || "your new plan";

    toast.success(
      `Payment successful. ${planLabel} is now active and your workspace can use the features included in that plan.`,
      {
        autoClose: 5000
      }
    );

    url.searchParams.delete("billing_status");
    url.searchParams.delete("billing_plan");
    window.history.replaceState({}, document.title, `${url.pathname}${url.search}${url.hash}`);
  }, []);

  return (
    <div className="page-wrapper">
      <ToastContainer position="bottom-right" autoClose={5000} />
      <div className="dashboard-wrapper-flex container">
        <div className="content-dashboard-wrapper">
          <DashboardToolbar />
          <DashboardBody />
        </div>
      </div>
    </div>
  );
}

export default DashboardAuthoring;
